module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"GiftMessage":"You have an active gift plan up to {date}. Time left until the end of the discount:","wageGiftBuy":"At the moment, with the discount plan active on your account, the purchase commission is calculated {percent}.","wageGiftSell":"Currently, with the discount plan active on your account, the sales commission is calculated at{percent}."}}')
  delete Component.options._Ctor
}
